import { Box, Typography } from "@material-ui/core";
import React from "react";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { PropertyRow } from "./PropertyRow";

export interface Overview {
  title: string;
  value: string;
  icon: string;
}

interface Props {
  properties: Array<Overview>;
  handleAddProperty: () => void;
  handleDeleteProperty: (propertyRowIndex: number) => void;
  handleChangeProperty: (
    index: number,
    fieldName: string,
    value: string | boolean
  ) => void;
}

export const OverviewBlock = ({
  properties,
  handleAddProperty,
  handleDeleteProperty,
  handleChangeProperty
}: Props) => {
  return (
    <Box className="overview" padding="2em">
      <div className="overview_headerRow">
        <Typography variant="h6" gutterBottom className="base-color">
          Overview
        </Typography>
      </div>
      <hr />
      {properties &&
        properties.map((item, i) => {
          return (
            <PropertyRow
              key={item.title + i}
              handleChangeRow={handleChangeProperty}
              deletePropertyRow={handleDeleteProperty}
              index={i}
              property={item}
            />
          );
        })}
      {properties.length === 0 ? <Typography>No properties</Typography> : null}
      {properties.length < 10 && <Box marginTop=".5em">
        <AddCircleIcon onClick={handleAddProperty} className="add-discount" />
      </Box>}
    </Box>
  );
};
